import { render } from "./aws-ebs.vue?vue&type=template&id=3f556289"
import script from "./aws-ebs.vue?vue&type=script&lang=js"
export * from "./aws-ebs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__